import React from 'react';

const About = () => {
  return (
    <div className="page-container">
      <h1>About UpDeals</h1>
      <p>
        Welcome to <strong>UpDeals</strong> — India's premier real-time discount and loot deal
        aggregator. We monitor top e-commerce retailers 24/7 to find verified price drops,
        hidden promotional coupons, flash sales, and free samples.
      </p>
      <p>
        Every deal posted on our platform is scanned and vetted for authenticity to ensure you
        never miss limited-time flash opportunities across Amazon, Flipkart, Myntra, Ajio, and more.
      </p>
    </div>
  );
};

export default About;
